import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired,
  ]),
  nav: PropTypes.node,
  actions: PropTypes.node,
  layout: PropTypes.oneOf(['full-nav', 'full-title', 'small-nav', 'top-nav']),
};

const Title = memo(({ className, icon, title, nav, actions, layout }) => {
  const classes = classNames({
    'pro-layout-title': true,
    'no-nav': !nav,
    'no-actions': !actions,
    [layout]: !!layout,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="pro-layout-title-main-content">
        {icon && (
          <div className="pro-layout-title-main-content-icon">
            {typeof icon === 'string' ? (
              <img src={getAsset(icon)} alt={title} />
            ) : (
              <>{icon}</>
            )}
          </div>
        )}
        <h2
          data-tip={title}
          data-for="tooltip-pro-layout-title"
          data-effect="solid"
        >
          {title}
        </h2>
        {typeof title === 'string' && (
          <ReactTooltip id="tooltip-pro-layout-title" className="tooltip" />
        )}
      </div>

      {nav && <div className="pro-layout-title-nav">{nav}</div>}
      {actions && <div className="pro-layout-title-actions">{actions}</div>}
    </div>
  );
});

Title.propTypes = propTypes;
Title.displayName = 'Title';

export default Title;
